// Libs
import _find from 'lodash/find'
import { createSelector } from 'reselect'

// Selectors
import grids$ from 'hfty-grid/src/selectors/grids'
import createDefaultGridForSelectedJob$ from 'hfty-grid/src/selectors/createDefaultGridForSelectedJob'
import selectedJob$ from './selectedJob'

// Exports
export default createSelector(
  [
    selectedJob$,
    grids$,
    createDefaultGridForSelectedJob$,
  ],
  function (selectedJob, grids, defaultGrid) {
    if (!selectedJob) { return null }
    const selectedGrid = _find(grids, (grid) => grid.job === selectedJob.id)
    if (selectedGrid) {
      return {
        ...selectedJob,
        grid: JSON.parse(selectedGrid.grid),
        grid_id: selectedGrid.id,
      }
    } else {
      return {
        ...selectedJob,
        grid: defaultGrid,
        grid_id: null,
      }
    }
  }
)
